<template>
    <div>
        <p>
            Service
            <b-select v-model="name_service" :options="[
                { text: 'Google Translate', value: 'google_translate' },
                { text: 'DeepL', value: 'deepl' }
            ]" />
        </p>
        <p>
            Langue source (deux lettres, ex: fr, en), détection automatique si non précisé
            <b-input v-model="source" placeholder="fr" />
        </p>
        <p>
            Langue de traduction (deux lettres, ex: fr, en)
            <b-input v-model="target" placeholder="en" />
        </p>

        <div class="mt-2">
            <strong>Colonnes</strong>
            <b-table-simple small bordered class="mt-1">
                <b-thead>
                    <b-tr>
                        <b-th>Colonne</b-th>
                        <b-th>Colonne de résultats</b-th>
                        <b-th></b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(row, idx) in columns" :key="'tr' + idx">
                        <b-td>
                            <b-input :list="'trfrom' + id" v-model="row.from" size="sm" />
                            <datalist :id="'trfrom' + id">
                                <option v-for="(c, ci) in columns_data" :key="'trf' + ci">{{ c }}</option>
                            </datalist>
                        </b-td>
                        <b-td>
                            <b-input v-model="row.to" size="sm" />
                        </b-td>
                        <b-td>
                            <b-button size="sm" variant="danger" @click="columns.splice(idx, 1)">✕</b-button>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-button size="sm" @click="columns.push({ from: '', to: '' })">+ Ajouter une colonne</b-button>
        </div>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    export default {
        name: "translate_step",
        props: {
            data: { default: () => [] },
            files: { default: () => [] },
            client: { default: null },
            size: { default: 1000 },
            step_position: { default: 0 }
        },
        watch: {
            data: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.data.length > 0) {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            }
        },
        data() {
            return {
                id: uniqueId(""),
                columns_data: [],

                name_service: "google_translate",
                source: "",
                target: "",
                columns: []
            };
        },
        methods: {
            save() {
                return {
                    name_service: this.name_service,
                    source: this.source,
                    target: this.target,
                    columns: this.columns
                };
            },
            async load(data) {
                if (!data) data = {};
                this.name_service = data.name_service || "google_translate";
                this.source = data.source || "";
                this.target = data.target || "";
                this.columns = Array.isArray(data.columns) ? data.columns.map(c => ({
                    from: c.from || "",
                    to: c.to || ""
                })) : [];
            }
        }
    };
</script>

<style scoped>
</style>
